import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getUserPolicy,
  getIdUserPolicy,
  createUserPolicy,
  updateUserPolicy,
  deleteUserPolicy,
  createOfficeMapping,
  deleteOfficeMaping,
  getUserPolicyMaster,
} from "./policyAPI";
import { createOffice } from "../office/officeAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  permissionUserPolicy: [],
};

export const fetchUserPolicy = createAsyncThunk(
  "UserPolicy/fetchUserPolicy",
  async (payload) => {
    const response = await getUserPolicy(payload);
    return response;
  }
);

export const addUserPolicy = createAsyncThunk(
  "UserPolicy/addUserPolicy",
  async (payload) => {
    const response = await createUserPolicy(payload);
    return response;
  }
);

export const editUserPolicy = createAsyncThunk(
  "UserPolicy/editUserPolicy",
  async (payload) => {
    const response = await updateUserPolicy(payload);
    return response;
  }
);

export const fetchIdUserPolicy = createAsyncThunk(
  "UserPolicy/fetchIdUserPolicy",
  async (id) => {
    const response = await getIdUserPolicy(id);
    return response;
  }
);

export const removeUserPolicy = createAsyncThunk(
  "UserPolicy/removeUserPolicy",
  async (payload) => {
    const response = await deleteUserPolicy(payload);
    return response;
  }
);

export const removeOfficeMapping = createAsyncThunk(
  "UserPolicy/removeOfficeMapping",
  async (payload) => {
    const response = await deleteOfficeMaping(payload);
    return response;
  }
);

export const addOfficeMapping = createAsyncThunk(
  "UserPolicy/addOfficeMapping",
  async (payload) => {
    const response = await createOfficeMapping(payload);
    return response;
  }
);

export const userPolicySlice = createSlice({
  name: "userPolicy",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionUserPolicy: (state, action) => {
      state.permissionUserPolicy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })

      .addCase(fetchIdUserPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdUserPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addUserPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUserPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editUserPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(editUserPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeUserPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeUserPolicy.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeOfficeMapping.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeOfficeMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addOfficeMapping.pending, (state) => {
        state.loading = true;
      })
      .addCase(addOfficeMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionUserPolicy,
} = userPolicySlice.actions;

export const selectUserPolicy = (state) => state.userPolicy.data;
export const selectIdUserPolicy = (state) => state.userPolicy.dataId;
export const selectLoading = (state) => state.userPolicy.loading;
export const selectError = (state) => state.userPolicy.error;
export const selectPageNo = (state) => state.userPolicy.pageNo;
export const selectPageSize = (state) => state.userPolicy.pageSize;
export const selectTotalRecord = (state) => state.userPolicy.totalRecord;
export const selectSelected = (state) => state.userPolicy.selected;
export const selectResult = (state) => state.userPolicy.result;
export const selectPermissionUserPolicy = (state) =>
  state.userPolicy.permissionUserPolicy;

export default userPolicySlice.reducer;
